// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1TsrO","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1zBRC"};